export default __webpack_public_path__ + "static/media/5.1c72cea9.jpg";